import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportBulkRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-bulk',
	path: '/secure/admin/BulkCreate(\\w+)([!%]?[\\w]*).jspa',
};
